module.exports = __webpack_public_path__ + "img/newsdetails7.480177c2.png";